import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsGrid } from './components/TestimonialsGrid';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FormatSection } from './components/FormatSection';
import { FaqSection } from './components/FaqSection';
import { ComparisonSection } from './components/ComparisonSection';
import { FinalCta } from './components/FinalCta';
import { FinalThoughts } from './components/FinalThoughts';
import { ContactSection } from './components/ContactSection';
import { SiteFooter } from './components/SiteFooter';
import { StickyBuyBar } from './components/StickyBuyBar';
type AppProps = {
  spotsLeft?: number;
  claimedPercent?: number;
  showStickyBuyBar?: boolean;
};
export function App({
  spotsLeft = 47,
  claimedPercent = 68,
  showStickyBuyBar = true
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-night font-sans" data-id="element-0" data-mp="2zmeowbge3q93">
      <TopBar spotsLeft={spotsLeft} data-id="element-1" data-mp="33mov9p83gioh" />
      <Hero data-id="element-2" data-mp="33nq5xsl7735o" />
      <main data-id="element-3" data-mp="33ngfk3w8qtzg">
        <StatsBar data-id="element-4" data-mp="33mymfg4vkvvr" />
        <TestimonialsStrip data-id="element-5" data-mp="33oi2b5mmd4x0" />
        <ProblemSection data-id="element-6" data-mp="38l8iru2c62iy" />
        <SolutionSection data-id="element-7" data-mp="38kqgafp2ys2l" />
        <VolumesSection data-id="element-8" data-mp="38kglmet3bwqk" />
        <BonusesSection data-id="element-9" data-mp="3dkuws5pznmst" />
        <OfferSection claimedPercent={claimedPercent} data-id="element-10" data-mp="3dl4n5uey3vz1" />
        <TestimonialsGrid data-id="element-11" data-mp="3diry6xarslch" />
        <GuaranteeSection data-id="element-12" data-mp="nvst52eusjuw" />
        <FormatSection data-id="element-13" data-mp="nuhicimzqbua" />
        <FaqSection data-id="element-14" data-mp="nvarfq9f9dfl" />
        <ComparisonSection data-id="element-15" data-mp="nxwvhfx3tat2" />
        <FinalCta data-id="element-16" data-mp="su43rfcz2ye6" />
        <FinalThoughts data-id="element-17" data-mp="stkoy7imcq4d" />
        <ContactSection data-id="element-18" data-mp="sssqmoxn0eae" />
      </main>
      <SiteFooter data-id="element-19" data-mp="3685nh1tcguh" />
      {showStickyBuyBar && <StickyBuyBar data-id="element-20" data-mp="356t1855fman" />}
    </div>;
}